import { Dialog, dialog } from '@flipster/react/design-system/dialog';
import { snackbar } from '@flipster/react/design-system/snackbar/index';
import { canSendNativeRequest, sendNativeRequest } from '@flipster/utils/simple-bridge/bridge';

// 시간 없어서 떔빵으로 만드는 wrapper. 추후 고도화 필요
export const showAlert = ({
  title,
  content,
  confirmText,
  closeText,
}: {
  title: string;
  content: string;
  confirmText: string;
  closeText?: string;
}) => {
  if (canSendNativeRequest) {
    sendNativeRequest({
      name: 'showAlert',
      callback: 'onShowAlertResult',
      params: {
        title,
        content,
        positive_button: confirmText,
        negative_button: closeText ?? null,
      },
    });
  } else {
    dialog.open({
      title: {
        label: title ?? 'Notice',
      },
      content: <div style={{ whiteSpace: 'pre-wrap' }}>{content}</div>,
      buttons: {
        primary: <Dialog.Button hierarchy='primary' label={confirmText ?? 'Confirm'} />,
      },
    });
  }
};

export const showSnackbar = ({
  message,
  type = 'success',
}: {
  message: string;
  type?: 'success' | 'warning' | 'error';
  buttonText?: string;
  buttonPage?: string;
}) => {
  if (canSendNativeRequest) {
    sendNativeRequest({
      name: 'showSnackbar',
      callback: 'onShowSnackbarResult',
      params: {
        icon: type.toUpperCase() as 'SUCCESS' | 'WARNING' | 'ERROR',
        message,
        button: null,
      },
    });
  } else {
    snackbar[type]({
      message,
    });
  }
};
